/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum SharedPreferenceMode {
    LOCAL_STORAGE,
    SESSION_STORAGE,
    FILE_SYSTEM,
}
